import { type ReactElement, type ReactNode } from 'react';

/**
 * The content column inside the sign-in showcase panel (the wordmark sits in the panel's own top row): children stacked with the
 * `--space-5` gap. Five apps (Admin, Balcão, Loja, Frota, Central) each carried a byte-identical copy of this with an inline style;
 * it is one component now (D548).
 */
export function AuthCard({ children }: { children: ReactNode }): ReactElement {
  return <section className="vello-auth-stack">{children}</section>;
}
